import Main from './Main.vue'
import cadastrar from './components/LocalizacaoVeiculo'

export default [{
  path: 'localizacao-veiculo',
  name: 'localizacao-veiculo',
  component: Main,
  children: [
    {path: '/', component: cadastrar, name: 'localizacao-veiculo'}
  ]
}]



// WEBPACK FOOTER //
// ./src/app/website/localizacao-veiculo/routes.js